<template>
  <div class="page">
    <div class="nav" v-if="!isWeChatFlag">
      <!--<div class="close" @click="close">-->
        <!--<img src="../../assets/image/CustomersInfo/icon_close.png"/>-->
      <!--</div>-->
      <p>车家-资料上传助手</p>
    </div>
    <div class="content">
      <div class="top">
        <img src="../../assets/image/CustomersInfo/success_icon.png">
        <p>提交成功</p>
      </div>
      <div class="btm">
        <!--<div class="notice">-->
          <!--<img src="../../assets/image/CustomersInfo/collect_notice.png"/>-->
          <!--<p>注意：为了提高审贷通过率，请注意以下情况</p>-->
        <!--</div>-->
        <div>
          <p>请留意接听 021-3183 开头的固定电话</p>
        </div>
      </div>
      <button @click="goCusCollect">完成</button>
    </div>
  </div>
</template>

<script>
  import common from "../../utils/common";
  import VueCookies from 'vue-cookies';
  import _ from 'lodash';
  export default {
    name: "Cus_CollectSuccess",
    data() {
      return {
        isWeChatFlag: false
      }
    },
    mounted() {
      this.$nextTick(()=>{
        window.scrollTo(0, 0)
        if (!VueCookies.get("tokenflag") || !sessionStorage.getItem("access_token")) {
          common.redirect(this, "");
          return;
        }
        this.isWeChatFlag = common.isWeChat()
      })
    },
    methods: {
      goCusCollect: _.throttle(function(){
        common.redirect(this, 'cus_collect')
      }),
      close: _.throttle(function () {
        common.redirect(this, '')
      })
    }

  }
</script>

<style scoped lang="less">
  .page {
    margin: 0 auto;
    width: 7.5rem;
    p{
      margin: 0;
    }
    .nav {
      width: 100%;
      height: 0.88rem;
      .close {
        position: absolute;
        top: 0;
        left: 0.17rem;
        width: 0.88rem;
        height: 0.88rem;
        display: flex;
        align-items: center;
        /*justify-content: center;*/
        img {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      p {
        font-size: 0.36rem;
        font-weight: 700;
        color: #000000;
        text-align: center;
        line-height: 0.88rem;
      }
    }

    .content {
      margin-top: 1.77rem;
      text-align: center;
      .top {
        /*border: 1px solid black;*/
        text-align: center;
        img {
          width: 1.26rem;
          height: 1.26rem;
        }
        p {
          margin-top: 0.18rem;
          font-size: 0.3rem;
          font-weight: 600;
          color: #3289FF;
          text-align: center;
          line-height: 0.42rem;
        }
        p:last-child {
          margin-top: 0.2rem;
          font-size: 0.3rem;
          font-weight: 600;
          color: #333333;
          text-align: center;
          line-height: 0.42rem;
        }
      }

      .btm {
        /*border: 1px solid black;*/
        margin-top: 0.63rem;
        text-align: center;
        .notice {
          margin: 0 auto;
          width: 6.3rem;
          height: 0.7rem;
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: center;
          background: rgba(50,137,255,0.14);
          border-radius: 0.08rem;
          img {
            width: 0.336rem;
            height: 0.336rem;
          }
          p {
            margin-left: 0.144rem;
            font-size: 0.26rem;
            color: #3289FF;
            text-align: center;
            line-height: 0.46rem;
          }
        }
        div:last-child {
          margin-top: 0.18rem;
          p {
            font-size: 0.26rem;
            color: #333333;
            text-align: center;
            line-height: 0.42rem;
          }
        }
      }

      button {
        margin-top: 0.71rem;
        width: 6.30rem;
        height: 0.9rem;
        background: #3289FF;
        border-radius: 0.08rem;
        border-width: 0;
        outline: none;
        font-size: 0.3rem;
        color: #FFFFFF;
        text-align: center;
      }
    }



  }
</style>



// WEBPACK FOOTER //
// src/components/CustomersInfo/Cus_CollectSuccess.vue